import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()((theme) => {
  return {
    buttonPrimaryIconOnly: {
      '&.MuiButton-sizeLarge:not(.Mui-disabled)': {
        backgroundColor: theme.tokens.colors.original.brand.primary,
        color: theme.tokens.colors.original.brand.primary,
        '&:hover:not(.buttonLoading)': {
          backgroundColor: theme.tokens.colors.original.brand.tertirary,
          color: theme.tokens.colors.original.brand.tertirary,
        },
      },
    },
  };
});

export default styles;
